module.exports = __webpack_public_path__ + "img/nawloc_2.f6345027.webp";